<template>
  <div>
    <div class="djt01">
      <div class="djt02">
        <img src="@/assets/images/type01.png" class="djt03" alt="">
        <p class="djt04" @click="addyj(0)">添加分类</p>
      </div>
    </div>
    <div class="djt05">
      <div class="djt06">
        <div class="djt07">分类</div>
        <div class="djt08">操作</div>
      </div>
        <el-skeleton animated :loading="loading" :count="6">
          <template slot="template">
            <el-skeleton-item variant="p" style="width: 100%;height: 80px;" />
          </template>
          <template>
            <div v-for="(item,index) in data.dataList" :key="'lis'+index">
              <div class="djt09" style="justify-content: normal">
                <div class="djy10">
                  <div class="djy11">
                    <img src="@/assets/images/mrty01.png" class="djy12" alt="">
                    <div class="djy13t3" @click="toXj(item)" title="点击查看下级分类">{{item.name}}</div>
                    <img src="@/assets/images/mrty03.png" @click="addyj(item)" class="djy14" alt="">
                    <img src="@/assets/images/jiaz04.gif" v-show="item.jiaz" class="djy14" alt="">
                  </div>
                  <div class="djy15">
                    <img src="@/assets/images/ed01.png" @click="toyEd(item)" class="djy16" alt="">
                  </div>
                </div>
              </div>
              <div v-show="item.is_xz">
                <div class="djt09" style="justify-content: normal" v-for="(ite,ind) in item.erji" :key="'ite'+ind">
                  <div class="djy10">
                    <div class="djy11">
                      <img style="margin-left: 50px" src="@/assets/images/mrty02.png" class="djy12" alt="">
                      <div class="djy13t3">{{ite.name}}</div>
                    </div>
                    <div class="djy15">
                      <img src="@/assets/images/sd01.png" title="锁定" @click="toSuo(ite)" class="djy16" alt="" v-if="ite.state == 1">
                      <img src="@/assets/images/sd02.png" title="解锁" @click="toSuo(ite)" class="djy16" alt="" v-else>
                      <img src="@/assets/images/ed01.png" @click="toyEd(ite)" class="djy16" alt="" style="margin-left: 20px">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </el-skeleton>
      <div class="djt09" style="border-bottom: none;margin-top: 5px;">
        <el-pagination
          @current-change="toPage"
          background
          :page-size="8"
          :page-count="data.totalPage"
          layout="prev, pager, next"
          class="djt29"
        >
        </el-pagination>
      </div>
    </div>

    <xc-model :loading="isModel" title="添加分类" :is_buttom="false" @cancel="cancel">
      <div slot="mbody">
        <div class="djt17">
          <div class="djt18">
            <div class="djt19">名称：</div>
            <input v-model="fl_name" type="text" placeholder="请输入分类名称" class="djt20">
          </div>
          <div class="djt18" style="margin-top: 20px">
            <div class="djt19">顺序：</div>
            <input v-model="fl_sx" type="text" placeholder="请输入分类顺序" class="djt20">
          </div>
          <div class="djt21">
            <div class="djt22" @click="shres">确认</div>
            <div class="djt22" style="margin-left: 50px" @click="cancel">取消</div>
          </div>
        </div>
      </div>
    </xc-model>
    <xc-model :loading="xgModel" title="修改分类" :is_buttom="false" @cancel="xg_cancel">
      <div slot="mbody">
        <div class="djt17">
          <div class="djt18">
            <div class="djt19">名称：</div>
            <input v-model="fl_xgname" type="text" placeholder="请输入分类名称" class="djt20">
          </div>
          <div class="djt18" style="margin-top: 20px">
            <div class="djt19">顺序：</div>
            <input v-model="fl_xgsx" type="text" placeholder="请输入分类顺序" class="djt20">
          </div>
          <div class="djt21">
            <div class="djt22" @click="xg_shres">确认</div>
            <div class="djt22" style="margin-left: 50px" @click="xg_cancel">取消</div>
          </div>
        </div>
      </div>
    </xc-model>
  </div>
</template>

<script>
  var me;
  var user;
  import httpUser from "@/api/user";
  import util from '@/util/util';
  export default {
    name: "type",
    data(){
      return{
        isModel:false,
        page:1,
        pageSize:8,
        loading:true,
        data:[],
        jiazl:false,
        fl_name:'',
        fl_sx:'',
        fl_xgname:'',
        fl_xgsx:'',
        xgModel:false,
        lsItem:[],
        is_addzj:false,
      }
    },
    created() {
      me = this;
      user = JSON.parse(sessionStorage.getItem('user'));
    },
    mounted() {
      let data = {
        companyid:user.companyId,
        pid:0,
        page:1,
        pageSize:me.pageSize
      }
      httpUser.getgoodssortlist(data).then(res => {
        console.log(res);
        me.data = res.data;
        me.data.dataList.forEach(function (item,index) {
          me.$set(item,'is_xz',false);
          me.$set(item,'jiaz',false);
        })
        me.loading = false;
      })
    },
    methods:{
      toSuo(ite){//锁定或解锁分类
        let menu = JSON.parse(sessionStorage.getItem('menu'));
        let is_auth = util.is_Auth(menu,'刀具柜管理','锁定分类');
        if (is_auth == false) {
          me.$message.error('暂无权限');
          return false;
        }
        me.$Loading.start();
        let data = {
          id:ite.id,
          state:''
        }
        if (ite.state == 1) {
          data['state'] = 2;
        } else {
          data['state'] = 1;
        }
        httpUser.opersortstate(data).then(res => {
          switch (res.code) {
            case "0000":
              let data = {
                companyid:user.companyId,
                pid:0,
                page:me.page,
                pageSize:me.pageSize
              }
              httpUser.getgoodssortlist(data).then(res => {
                console.log(res);
                me.data = res.data;
                me.data.dataList.forEach(function (item,index) {
                  me.$set(item,'is_xz',false);
                  me.$set(item,'jiaz',false);
                })
                me.$Loading.finish();
                me.$message.success('修改成功');
              })
              break;
            case "1111":
              me.$Loading.error();
              me.$message.error('请稍后再试');
              break;
          }
        })
      },
      toyEd(item){//to编辑分类
        let menu = JSON.parse(sessionStorage.getItem('menu'));
        let is_auth = util.is_Auth(menu,'刀具柜管理','添加修改分类');
        if (is_auth == false) {
          me.$message.error('暂无权限');
          return false;
        }
        me.lsItem = item;
        me.fl_xgname = item.name;
        me.fl_xgsx = item.num;
        me.xgModel = true;
      },
      xg_shres(){//确认修改
        // console.log([me.fl_xgname,me.fl_xgsx]);return false;
        if (me.fl_xgname == '' || me.fl_xgname.indexOf(' ') != -1) {
          me.$message.error('分类名称格式错误');
          return false;
        }
        if (me.fl_xgsx == '' || me.fl_xgsx.toString().indexOf(' ') != -1) {
          me.$message.error('分类顺序格式错误');
          return false;
        }
        if (!(/(^[1-9]\d*$)/.test(me.fl_xgsx))) {
          me.$message.error('分类顺序只能为正整数');
          return false;
        }
        me.$Loading.start();
        let data = {
          id:me.lsItem.id,
          name:me.fl_xgname,
          num:me.fl_xgsx,
          state:me.lsItem.state,
          companyid:user.companyId,
        }
        httpUser.addorupdatesort(data).then(res => {
          let data = {
            companyid:user.companyId,
            pid:0,
            page:me.page,
            pageSize:me.pageSize
          }
          httpUser.getgoodssortlist(data).then(res => {
            console.log(res);
            me.data = res.data;
            me.data.dataList.forEach(function (item,index) {
              me.$set(item,'is_xz',false);
              me.$set(item,'jiaz',false);
            })
            me.xgModel = false;
            me.$Loading.finish();
            me.$message.success('修改成功');
          })
        })
      },
      shres(){//确定添加分类
        if (me.fl_name == '' || me.fl_name.indexOf(' ') != -1) {
          me.$message.error('分类名称格式错误');
          return false;
        }
        if (me.fl_sx == '' || me.fl_sx.toString().indexOf(' ') != -1) {
          me.$message.error('分类顺序格式错误');
          return false;
        }
        if (!(/(^[1-9]\d*$)/.test(me.fl_sx))) {
          me.$message.error('分类顺序只能为正整数');
          return false;
        }
        me.$Loading.start();
        let data = {
          name:me.fl_name,
          num:me.fl_sx,
          state:1,
          pid:0,
          companyid:user.companyId
        }
        if (me.is_addzj == true) {
          data['pid'] = me.lsItem.id;
        }
        httpUser.addorupdatesort(data).then(res => {
          switch (res.code) {
            case "0000":
              let data = {
                companyid:user.companyId,
                pid:0,
                page:me.page,
                pageSize:me.pageSize
              }
              httpUser.getgoodssortlist(data).then(res => {
                console.log(res);
                me.data = res.data;
                me.data.dataList.forEach(function (item,index) {
                  me.$set(item,'is_xz',false);
                  me.$set(item,'jiaz',false);
                })
                me.isModel = false;
                me.fl_name = '';
                me.fl_sx = '';
                me.$Loading.finish();
                me.$message.success('已添加');
              })
              break;
            case "1111":
              me.$Loading.error();
              me.$message.error('请稍后再试');
              break;
          }
        })
      },
      toXj(item){//查看下级分类
        if (item.is_xz == false) {
          item.jiaz = true;
          let data = {
            companyid:user.companyId,
            pid:item.id,
            page:1,
            pageSize:10000,
          }
          httpUser.getgoodssortlist(data).then(res => {
            console.log(res);
            me.$set(item,'erji',res.data.dataList);
            item.jiaz = false;
            item.is_xz = true;
          })
        } else {
          item.is_xz = false;
        }
      },
      addyj(item){//添加一级分类
        let menu = JSON.parse(sessionStorage.getItem('menu'));
        let is_auth = util.is_Auth(menu,'刀具柜管理','添加修改分类');
        if (is_auth == false) {
          me.$message.error('暂无权限');
          return false;
        }
        if (item == 0) {
          me.is_addzj = false;
        } else {
          me.is_addzj = true;
          me.lsItem = item;
        }
        me.isModel = true;
      },
      cancel(){//添加框点击返回
        me.isModel = false;
        me.fl_name = '';
        me.fl_sx = '';
      },
      xg_cancel(){
        me.xgModel = false;
      },
      toPage(e){//分页
        me.loading = true;
        let data = {
          companyid:user.companyId,
          pid:0,
          page:parseInt(e),
          pageSize:me.pageSize
        }
        me.page = e;
        httpUser.getgoodssortlist(data).then(res => {
          console.log(res);
          me.data = res.data;
          me.data.dataList.forEach(function (item,index) {
            me.$set(item,'is_xz',false);
          })
          me.loading = false;
        })
      },
    }
  }
</script>

<style scoped>
@import "djtype.css";
</style>